






import { isPosteTheme } from '@/components/RenderWithTheme.vue'
export default {
  props: {
    tag: { type: String, default: 'h1' }
  },
  computed: {
    isPosteTheme() {
      return isPosteTheme
    }
  }
}
